<template>
    <BaseCard theme="cream" radius="lgr" padding="none" class="flex flex-col items-center gap-7.5 p-7.5">
        <ReflectionIcon kind="sixty" size="hero" />
        <div class="flex flex-col gap-2.5 w-full">
            <h2 class="display-small-serif text-center text-valence-stone-900">Start a 360</h2>
            <p class="body text-valence-stone-500">
                A short, anonymous read on how your peers, reports, and manager see you — turned into two or three concrete goals. Setup takes about 3 minutes.
            </p>
        </div>

        <ol class="flex flex-col gap-4.5 w-full">
            <li v-for="step in steps" :key="step.n" class="flex items-start gap-3.5">
                <span class="flex items-center justify-center w-6.25 h-6.25 shrink-0 rounded-full bg-valence-cream-300 scaffold-body-small text-valence-stone-700">
                    {{ step.n }}
                </span>
                <p class="scaffold-body text-valence-stone-500">
                    <span class="font-semibold text-valence-stone-700">{{ step.title }}</span>
                    {{ step.body }}
                </p>
            </li>
        </ol>

        <!-- LAB-988: BaseButton isn't used for this bare CTA since we're not
             loading it just for a class shell; `base-btn-dark` overrides
             `base-btn-primary`'s color + radius. -->
        <button type="button" class="base-btn-dark base-btn-sm whitespace-nowrap" @click="emit('start')">Launch</button>
    </BaseCard>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import ReflectionIcon from "~vue/pages/reflections/ReflectionIcon.vue";

const emit = defineEmits<{ (event: "start"): void }>();

const steps = [
    { n: 1, title: "Invite your raters:", body: "peers, direct reports and manager" },
    { n: 2, title: "They answer", body: "a short set of questions, anonymously." },
    { n: 3, title: "Get themes and set goals", body: "a report of key themes and create goals" },
];
</script>
